class Relation {
    static serialize(relations) {
        return relations.join();
    }
}

export default Relation;